module.exports = __webpack_public_path__ + "static/media/4전쟁-빨간나라파란나라.a3990338.mp3";